module.exports = __webpack_public_path__ + "images/article-1-cover.jpg";